const RightAnswer = ({ className }) => {
    return (
      <span className={className}>
           <svg width='22' height='18' viewBox='0 0 22 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M2 9.50005L7.425 14L19.5 1.92505' stroke='currentColor' strokeWidth='5'/>
            </svg>
        </span>
    );
};

export default RightAnswer;
